import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Badge } from "../badge/Badge";
import { IdBadgePosition } from "../badge/IdBadgePosition";
import { Button } from "../button/Button";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
export var HudButton = function (_a) {
    var onClick = _a.onClick, icon = _a.icon, _b = _a.showNotificationIcon, showNotificationIcon = _b === void 0 ? true : _b;
    if (icon == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var badge = !showNotificationIcon ? (React.createElement(React.Fragment, null)) : (React.createElement(Badge, { position: IdBadgePosition.TopRight, className: "hud-button__alert-icon" },
        React.createElement(Icon, { icon: IdIcon.QuestUpdateIcn, styleId: IdStyles.IconSmall })));
    return (React.createElement(Button, { onClick: onClick, className: "hud-button__button" },
        React.createElement("div", { className: IdStyles.FloatingButtonBackground + " hud-button__container flex flex--guts" },
            React.createElement("div", { className: "hud-button__icon" },
                React.createElement(Icon, { icon: icon, styleId: IdStyles.IconExtraLarge })),
            badge)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/hud-button/HudButton.tsx
// module id = 883
// module chunks = 3